module.exports = __webpack_public_path__ + "img/banner2.d64c097c.png";